import styled from "styled-components";
import { ProgressTextProps } from "./types.js";

export const ProgressTextContainer = styled.span<{
    textAlign?: ProgressTextProps["textAlign"];
    orientation: ProgressTextProps["orientation"];
}>`
    display: flex;
    flex-direction: ${(props) => props.orientation};
    align-items: center;
    justify-content: ${({ textAlign }) => (textAlign === "right" ? "flex-end" : "flex-start")};
    gap: ${(props) => (props.orientation === "row" ? props.theme.spacing[8] : 0)};
`;
